import { useState } from 'react';

import PaymentKPIBox from './PaymentKPIBox'
export default function PaymentduePage() {
	
	const [pageReady, setPageReady] = useState(true);
	return (
		<main id="PaymentduePage" className="main-page">
<section className="page-section q-pa-md" >
    <div className="container-fluid">
        <div className="grid ">
            <div className="col comp-grid" >
                <div className="">
                    <div><PaymentKPIBox/></div>
                </div>
            </div>
        </div>
    </div>
</section>
		</main>
	);
}
